import { Tire, Undercarriages } from "@/@types";
import UsedProductUndercarriageContent from "./UsedProductUndercarriageContent";
import UsedProductTireContent from "./UsedProductTireContent";

type Props = {
    activeCategory: string | null;
    groupedSections: Record<string, any>;
    undercarriages?: Undercarriages[];
    tires?: Tire[];
    classificationMap: Record<string, { label: string; color: string }>;
    isMobile?: boolean;
}

export default function UsedProductCategoryContent({
    activeCategory,
    groupedSections,
    undercarriages,
    tires,
    classificationMap,
    isMobile = false,
}: Props) {
    if (!activeCategory) return null;

    const isUndercarriage = activeCategory === "TREN DE RODAJE";
    const isTires = activeCategory === "NEUMÁTICOS";

    const currentSection = groupedSections[activeCategory];
    if (!currentSection && !isTires && !isUndercarriage) return null;

    const sortedDiscrete = currentSection.discreteFeatures
        ?.slice()
        .sort((a: any, b: any) =>
            a.concept.localeCompare(b.concept, "es")
        );

    const sortedBoolean = currentSection.booleanFeatures
        ?.slice()
        .sort((a: any, b: any) =>
            a.concept.localeCompare(b.concept, "es")
        );

    const sortedNoteFeatures = currentSection.noteFeatures
        ?.slice()
        .sort((a: any, b: any) =>
            a.concept.localeCompare(b.concept, "es")
        );

    if (undercarriages && undercarriages.length > 0 && isUndercarriage) {
        return (
            <UsedProductUndercarriageContent undercarriages={undercarriages} noteFeatures={sortedNoteFeatures} />
        );
    }

    if (tires && tires.length > 0 && isTires) {
        return (
            <UsedProductTireContent tires={tires} noteFeatures={sortedNoteFeatures} />
        );
    }

    return (
        <>
        {/* MOBILE */}
        {isMobile && isMobile === true && (
            <div className="lg:hidden">
                <table className="w-full text-sm">
                <tbody>
                    {sortedDiscrete?.map((item: any, index: number) => {
                    const classification = classificationMap[item.value];

                    return (
                        <tr key={index} className="border-t">
                        <td className="py-2 pl-4 border-r uppercase">{item.concept}</td>
                        <td className="py-2 text-center">
                            <span
                            className={`w-3 h-3 inline-block rounded-full ${classification?.color}`}
                            />
                        </td>
                        </tr>
                    );
                    })}

                    {sortedBoolean?.map((item: any, index: number) => (
                    <tr key={`bool-${index}`} className="border-t">
                        <td className="py-2 pl-4 border-r uppercase">{item.concept}</td>
                        <td className="py-2 text-center">
                        {item.value === "1" ? "Sí" : "No"}
                        </td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </div>
        )}

        {/* DESKTOP */}
        <div className="hidden lg:block">
            <table className="w-full text-sm">
                <thead>
                    <tr className="bg-gray-100">
                    <th className="py-2 text-left pl-4">MEDIDA</th>
                    <th className="py-2 text-center">VALOR</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedDiscrete?.map((item: any, index: number) => {
                    const classification = classificationMap[item.value];

                    return (
                        <tr key={index} className="border">
                        <td className="py-2 border-r pl-4 uppercase">{item.concept}</td>
                        <td className="py-2 text-center">
                            <span
                            className={`w-3 h-3 inline-block rounded-full ${classification?.color}`}
                            />
                        </td>
                        </tr>
                    );
                    })}

                    {sortedBoolean?.map((item: any, index: number) => (
                    <tr key={`bool-${index}`} className="border">
                        <td className="py-2 border-r pl-4 uppercase">{item.concept}</td>
                        <td className="py-2 text-center">
                        {item.value === "1" ? "Sí" : "No"}
                        </td>
                    </tr>
                    ))}

                    {sortedNoteFeatures?.map((item: any, index: number) => (
                    <tr key={`note-${index}`} className="border">
                        <td className="py-2 border-r pl-4 uppercase">{item.concept}</td>
                        <td className="py-2 px-2 text-center">
                        {item.value || item.note || "-"}
                        </td>
                    </tr>
                    ))}
                </tbody>
            </table>
        </div>
        </>
    );
}